import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeTakeaway'
})
export class FilterPipeTakeaway implements PipeTransform {
    transform(orders: any, term?: any): any {
        if (term === undefined) return orders;
        if (term === null) return orders;
        if (orders != null) {
            return orders.filter(function (order) {
                if (order.ticket.number != undefined)
                    if (order.ticket.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return order;
                if (order.UID != undefined)
                    if (order.UID.toString().toLowerCase().includes(term.toLowerCase()))
                        return order;
                if (order.ticket.delivery != undefined)
                    if (order.ticket.delivery.toString().toLowerCase().includes(term.toLowerCase()))
                        return order;
                if (order.customer_name != undefined)
                    if (order.customer_name.toString().toLowerCase().includes(term.toLowerCase()))
                        return order;
                if (order.customer_phone != undefined)
                    if (order.customer_phone.toString().toLowerCase().includes(term.toLowerCase()))
                        return order;
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-select-orders/filter.pipe.ts